import { createAsyncThunk } from '@reduxjs/toolkit'
import okHttp from '@helper/okHttp'
import { onlinecs, getTypePrefix  } from '@/api'

/**
 * 客户列表
 * @type {AsyncThunk<Promise<*>, void, AsyncThunkConfig>}
 */
export const getRobotBasicConfigAction = createAsyncThunk(
    getTypePrefix(onlinecs.getRobotBasicConfigUrl),
    async (data) => await okHttp(onlinecs.getRobotBasicConfigUrl, {
        method: 'POST',
	    data
    })
)

/**
 * 注册应用列表
 * @type {AsyncThunk<Promise<*>, void, AsyncThunkConfig>}
 */
export const modifyConfigAction = createAsyncThunk(
    getTypePrefix(onlinecs.modifyConfigUrl),
    async (data) => await okHttp(onlinecs.modifyConfigUrl, {
        method: 'POST',
	    data
    })
)

/**
 * 获取所有客服
 * @type {AsyncThunk<Promise<*>, void, AsyncThunkConfig>}
 */
export const getAllEmployeeListAction = createAsyncThunk(
    getTypePrefix(onlinecs.getAllEmployeeListUrl),
    async (params) => await okHttp(onlinecs.getAllEmployeeListUrl, {
        method: 'GET',
	    params
    })
)


